import { api } from "@/services/api"

type UpdatePasswordRequest = {
  password: string
}

export const updatePassword = async (
  params: UpdatePasswordRequest
) => {
  await api.post("/password/set/", {
    body: params,
  })
}
